import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  FileParameter,
  StudentsClient,
} from '../../../generated-client/generated-api-client';
import { Router } from '@angular/router';
import { ErrorProcessorService } from '../../../services/error-processor.service';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { fileSizeValidator } from "../../../custom-validators/fileSizeValidator";
import { environment } from "@env/environment";
import { saveAs } from "file-saver";
import { ToastrService } from "ngx-toastr";

export interface StudentImportModal {
  examReportId: string;
}

@Component({
  selector: 'app-student-import-modal',
  templateUrl: './student-import-modal.component.html',
  styleUrls: ['./student-import-modal.component.sass'],
})
export class StudentImportModalComponent
  extends SimpleModalComponent<StudentImportModal, boolean>
  implements StudentImportModal {
  examReportId!: string;
  importForm: FormGroup;
  maxFileSizeMb: number = environment.maxFileSizeBytes / 1024 / 1024;
  isImporting: boolean = false;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  errors: string[] = [];

  constructor(
    private _router: Router,
    private _studentsClient: StudentsClient,
    private _errorProcessor: ErrorProcessorService,
    private _toastr: ToastrService,
  ) {
    super();

    this.importForm = new FormGroup({
      file: new FormControl(null, [Validators.required, fileSizeValidator(this.fileInput, environment.maxFileSizeBytes)]),
      stopOnFirstError: new FormControl(false),
    });


  }

  confirm() {
    const file = this.fileInput.nativeElement.files![0];
    const fp: FileParameter = {
      data: file,
      fileName: file.name,
    };

    this._toastr.info('Az importálás elkezdődött.');
    this.isImporting = true;

    this._studentsClient
      .import(this.examReportId, this.stopOnFirstError.value as boolean, fp)
      .subscribe(
        result => {
          this._toastr.success('Sikeresen importálva.');
          this.result = true;
          this.close();
          this.isImporting = false;
        },
        error => {
          const statusCode = error.statusCode ?? error.status;
          if (statusCode == '400') {
            this.errors = error.errors[''];
          }
          this.isImporting = false;
        }
      );
  }

  copyToClipboard(errors: string[]): void {
    navigator.clipboard.writeText(errors.join("\n")).then(() => {
      this._toastr.info('Vágólapra másolva');
    }).catch(err => {
      console.error("Másolási hiba:", err);
    });
  }

  downloadExampleFile() {
    this._studentsClient.downloadImportExampleExcel().subscribe(
      result => {
        saveAs(result.data, result.fileName);
      },
      error => this._errorProcessor.processError(error, true)
    );
  }

  get file() {
    return this.importForm.get('file')!;
  }

  get stopOnFirstError() {
    return this.importForm.get('stopOnFirstError')!;
  }

}
